// web-frontend/src/tutorial/translations.js
// Self-contained i18n strings for the tutorial layer.

const TRANSLATIONS = {
  ko: {
    // ---- common UI ----
    'common.skip': '튜토리얼 건너뛰기',
    'common.next': '다음',
    'common.prev': '이전',
    'common.done': '완료',
    'common.start': '시작하기',
    'common.gotIt': '알겠습니다',
    'common.progress': '단계 {i}/{n}',
    'common.replay_button': '튜토리얼 다시 보기',
    'common.replay_desc': '앱 사용법 가이드를 처음부터 다시 시청합니다.',
    'common.replay_section': '앱 가이드',
    'common.show_steps': '전체 단계 보기',
    'common.hide_steps': '전체 단계 숨기기',
    'common.steps_panel_label': '튜토리얼 진행 상황',

    // ---- language picker (first tutorial step) ----
    'picker.title': '언어를 선택하세요',
    'picker.subtitle': '선택한 언어로 앱과 튜토리얼이 표시되며, 프로필에 저장됩니다.',
    'picker.note': '나중에 설정에서 언제든지 변경할 수 있습니다.',
    'picker.step_title': '언어 선택',

    // ---- shared ----
    'shared.open_menu.title': '메뉴 열기',
    'shared.open_menu.body': '왼쪽 상단의 메뉴(☰) 버튼을 탭해 메뉴를 여세요.',

    // ============================================================
    // COMPANY (참가 기업)
    // ============================================================
    'company.welcome.title': '환영합니다!',
    'company.welcome.body': '{eventName}이 처음이시죠? 핵심 기능을 빠르게 안내해 드릴게요. 언제든 우측 상단의 "튜토리얼 건너뛰기"로 종료할 수 있어요.',
    'company.companies.title': '기업 둘러보기',
    'company.companies.body': '"기업" 메뉴에서 다른 참가 기업을 살펴보고 협력 가능성을 발견하세요.',
    'company.events.title': '일정 확인',
    'company.events.body': '"일정"에서 {eventName}의 컨퍼런스, 네트워킹, 피칭 등 다양한 이벤트 일정을 확인할 수 있어요.',
    'company.matching.title': 'AI 매칭으로 이동',
    'company.matching.body': '👉 지금 좌측 메뉴의 "매칭" 버튼을 클릭해 주세요. 클릭하면 AI 기반 비즈니스 매칭 화면으로 이동합니다.',
    'company.aiBtn.title': '관심분야 기반 분석',
    'company.aiBtn.body': '👉 강조된 "관심분야 기반 분석" 버튼을 클릭해 주세요. AI 분석이 시작됩니다.',
    'company.analyzing.title': 'AI 분석 중',
    'company.analyzing.body': '약 30초간 "AI Analyzing..." 메시지가 표시됩니다. 잠시만 기다려 주세요.',
    'company.analyzed.title': '분석 완료!',
    'company.analyzed.body': '상단에 "Analyzed" 배지가 표시되었어요. 추천 결과를 확인해 보세요.',
    'company.chats.title': '비즈니스 채팅',
    'company.chats.body': '관심 있는 기업과 직접 메시지를 주고받고, 미팅을 제안할 수 있어요.',
    'company.profile.title': '회사 정보 관리',
    'company.profile.body': '"프로필"에서 회사 소개, 담당자 연락처, 부스 정보 등을 수정할 수 있어요.',
    'company.carbon.title': '탄소 감축 활동',
    'company.carbon.body': '친환경 활동을 기록하면 탄소 감축량이 누적됩니다. 메뉴 하단에서 현황을 확인하세요.',
    'company.done.title': '준비 완료',
    'company.done.body': '잘 따라오셨어요! 더 알고 싶다면 "설정 → 앱 가이드"에서 언제든 다시 시청할 수 있습니다.',

    // ============================================================
    // BUYER verified (초청 바이어 - 승인 완료)
    // ============================================================
    'buyer.welcome.title': '환영합니다, 바이어님!',
    'buyer.welcome.body': '관심사 기반 AI 매칭으로 최적의 공급처를 빠르게 찾아드립니다. 주요 기능을 안내해 드릴게요.',
    'buyer.companies.title': '공급사 카탈로그',
    'buyer.companies.body': '"기업" 메뉴에서 산업/규모/기술별로 공급사를 둘러볼 수 있어요.',
    'buyer.events.title': '일정 확인',
    'buyer.events.body': '"일정"에서 참여하고 싶은 컨퍼런스나 네트워킹 이벤트를 미리 북마크하세요.',
    'buyer.matching.title': 'AI 매칭으로 이동',
    'buyer.matching.body': '👉 지금 좌측 메뉴의 "매칭" 버튼을 클릭해 주세요. 회원님의 관심사 기반 추천 화면으로 이동합니다.',
    'buyer.aiBtn.title': '관심분야 기반 분석',
    'buyer.aiBtn.body': '👉 강조된 "관심분야 기반 분석" 버튼을 클릭해 주세요. AI가 회원님의 관심사를 분석합니다.',
    'buyer.analyzing.title': 'AI 분석 중',
    'buyer.analyzing.body': '약 30초간 "AI Analyzing..." 메시지가 표시됩니다.',
    'buyer.analyzed.title': '분석 완료!',
    'buyer.analyzed.body': '상단에 "Analyzed" 배지가 표시되었어요. 추천 공급사를 확인하세요.',
    'buyer.chats.title': '공급사와 채팅',
    'buyer.chats.body': '관심 공급사와 직접 메시지를 주고받고, 미팅을 제안할 수 있어요.',
    'buyer.profile.title': '내 정보 관리',
    'buyer.profile.body': '"프로필"에서 관심 분야와 연락처를 갱신하면 매칭 정확도가 올라갑니다.',
    'buyer.carbon.title': '탄소 감축 활동',
    'buyer.carbon.body': '친환경 활동을 기록하면 탄소 감축량이 누적됩니다. 메뉴 하단에서 확인하세요.',
    'buyer.done.title': '준비 완료',
    'buyer.done.body': '관심 공급사는 북마크해 두면 한곳에 모아 볼 수 있어요. "설정 → 앱 가이드"에서 다시 시청 가능합니다.',

    // ============================================================
    // BUYER pending (승인 대기)
    // ============================================================
    'buyerPending.welcome.title': '승인 대기 중',
    'buyerPending.welcome.body': '바이어 가입 신청이 접수되었어요. 보통 수 시간 내 승인됩니다. 그동안 둘러보실 수 있는 주요 기능을 안내해 드릴게요.',
    'buyerPending.companies.title': '기업 둘러보기',
    'buyerPending.companies.body': '"기업" 메뉴에서 참가 기업을 미리 살펴볼 수 있어요. 매칭/채팅은 승인 후 활성화됩니다.',
    'buyerPending.events.title': '일정 확인',
    'buyerPending.events.body': '"일정"에서 참여하고 싶은 이벤트를 미리 북마크해 두세요.',
    'buyerPending.profile.title': '내 정보',
    'buyerPending.profile.body': '"프로필"에서 가입 정보와 승인 상태를 확인할 수 있어요. 알림이 오면 즉시 매칭/채팅이 열립니다.',
    'buyerPending.done.title': '안내 완료',
    'buyerPending.done.body': '승인이 완료되면 매칭/채팅 기능이 자동으로 열리고 알림이 도착합니다.',

    // ============================================================
    // BUSINESS_VISITOR verified
    // ============================================================
    'bizvisitor.welcome.title': '환영합니다, 비즈니스 비지터님!',
    'bizvisitor.welcome.body': 'AI 매칭으로 관심 분야의 기업을 빠르게 찾을 수 있어요. 주요 기능을 안내해 드릴게요.',
    'bizvisitor.companies.title': '기업 둘러보기',
    'bizvisitor.companies.body': '"기업" 메뉴에서 산업/규모/기술별로 참가 기업을 탐색할 수 있어요.',
    'bizvisitor.events.title': '일정 확인',
    'bizvisitor.events.body': '"일정"에서 컨퍼런스, 네트워킹, 피칭 등 이벤트를 확인할 수 있어요.',
    'bizvisitor.matching.title': 'AI 매칭으로 이동',
    'bizvisitor.matching.body': '👉 지금 좌측 메뉴의 "매칭" 버튼을 클릭해 주세요. AI 추천 화면으로 이동합니다.',
    'bizvisitor.aiBtn.title': '관심분야 기반 분석',
    'bizvisitor.aiBtn.body': '👉 강조된 "관심분야 기반 분석" 버튼을 클릭해 주세요. AI 분석이 시작됩니다.',
    'bizvisitor.analyzing.title': 'AI 분석 중',
    'bizvisitor.analyzing.body': '약 30초간 "AI Analyzing..." 메시지가 표시됩니다.',
    'bizvisitor.analyzed.title': '분석 완료!',
    'bizvisitor.analyzed.body': '상단의 "Analyzed" 배지를 확인하세요. 추천 결과가 준비되었어요.',
    'bizvisitor.chats.title': '기업과 채팅',
    'bizvisitor.chats.body': '관심 기업에 직접 메시지를 보내고 미팅을 제안할 수 있어요.',
    'bizvisitor.profile.title': '내 정보 관리',
    'bizvisitor.profile.body': '"프로필"에서 관심 분야와 연락처를 갱신하면 매칭 정확도가 올라가요.',
    'bizvisitor.carbon.title': '탄소 감축 활동',
    'bizvisitor.carbon.body': '친환경 활동을 기록하면 탄소 감축량이 누적됩니다.',
    'bizvisitor.done.title': '준비 완료',
    'bizvisitor.done.body': '"설정 → 앱 가이드"에서 언제든 다시 시청할 수 있어요.',

    // ============================================================
    // BUSINESS_VISITOR pending
    // ============================================================
    'bizvisitorPending.welcome.title': '승인 대기 중',
    'bizvisitorPending.welcome.body': '비즈니스 비지터 신청이 접수되었습니다. 사무국 승인 후 매칭/채팅 기능이 열립니다. 그동안 둘러보실 곳을 안내해 드릴게요.',
    'bizvisitorPending.companies.title': '기업 둘러보기',
    'bizvisitorPending.companies.body': '"기업" 메뉴에서 참가 기업 목록을 살펴볼 수 있어요.',
    'bizvisitorPending.events.title': '일정 확인',
    'bizvisitorPending.events.body': '"일정"에서 관심 있는 이벤트를 미리 북마크해 두세요.',
    'bizvisitorPending.profile.title': '내 정보',
    'bizvisitorPending.profile.body': '"프로필"에서 승인 상태를 확인할 수 있어요. 승인되면 알림이 도착합니다.',
    'bizvisitorPending.done.title': '안내 완료',
    'bizvisitorPending.done.body': '승인이 완료되면 매칭/채팅이 자동으로 열립니다.',

    // ============================================================
    // INVESTOR
    // ============================================================
    'investor.welcome.title': '환영합니다, 투자자님!',
    'investor.welcome.body': '주목할 만한 스타트업을 효율적으로 발견할 수 있도록 도와드릴게요. 주요 기능을 안내해 드릴게요.',
    'investor.companies.title': '스타트업 탐색',
    'investor.companies.body': '"기업" 메뉴에서 산업/규모/투자단계별로 필터링하며 스타트업을 살펴보세요.',
    'investor.bookmark.title': '관심 기업 북마크',
    'investor.bookmark.body': '기업 카드의 북마크 아이콘을 누르면 "프로필 → 북마크"에서 한곳에 모아볼 수 있어요.',
    'investor.events.title': '피칭 & 네트워킹',
    'investor.events.body': '"일정"에서 피칭 세션과 네트워킹 이벤트를 확인하세요.',
    'investor.chats.title': '기업과 채팅',
    'investor.chats.body': '관심 기업과 직접 메시지를 주고받고 미팅을 제안할 수 있어요.',
    'investor.profile.title': '내 정보 관리',
    'investor.profile.body': '"프로필"에서 투자 영역과 관심 분야를 갱신하세요.',
    'investor.done.title': '준비 완료',
    'investor.done.body': '"설정 → 앱 가이드"에서 언제든 다시 시청 가능합니다.',

    // ============================================================
    // VISITOR (일반 관람객)
    // ============================================================
    'visitor.welcome.title': '{eventName}에 오신 걸 환영합니다',
    'visitor.welcome.body': '둘러보기 좋은 곳들을 빠르게 안내해 드릴게요.',
    'visitor.companies.title': '참가 기업 둘러보기',
    'visitor.companies.body': '"기업" 메뉴에서 참가 기업과 부스 위치를 확인할 수 있어요.',
    'visitor.events.title': '일정 확인',
    'visitor.events.body': '"일정"에서 관심 있는 컨퍼런스/세미나를 미리 북마크할 수 있어요.',
    'visitor.carbon.title': '나의 탄소 감축량',
    'visitor.carbon.body': '메뉴 하단의 탄소 위젯에서 친환경 활동으로 줄어든 탄소량을 확인하세요.',
    'visitor.profile.title': '내 정보 관리',
    'visitor.profile.body': '"프로필"에서 가입 정보와 알림 설정을 관리할 수 있어요.',
    'visitor.upgrade.title': '비즈니스 기능을 더 쓰고 싶다면?',
    'visitor.upgrade.body': '채팅·매칭·미팅 제안은 비즈니스 회원 전용입니다. 관심 있으시면 프로필에서 신청하실 수 있어요.',
    'visitor.upgrade.cta': '비즈니스 회원 신청 보기',
    'visitor.done.title': '준비 완료',
    'visitor.done.body': '즐거운 관람 되세요! "설정 → 앱 가이드"에서 다시 시청할 수 있어요.',

    // ============================================================
    // GUEST
    // ============================================================
    'guest.welcome.title': '미리보기 모드',
    'guest.welcome.body': '게스트로 둘러볼 수 있는 곳들을 안내해 드릴게요.',
    'guest.companies.title': '공개 카탈로그',
    'guest.companies.body': '"기업"에서 참가 기업 목록을 자유롭게 볼 수 있어요.',
    'guest.events.title': '공개 일정',
    'guest.events.body': '"일정"에서 행사 스케줄을 미리 살펴볼 수 있어요.',
    'guest.register.title': '회원가입으로 모든 기능 사용',
    'guest.register.body': '채팅·매칭·미팅 제안은 회원 전용입니다. 가입은 1분이면 됩니다.',
    'guest.register.cta': '회원가입 하러 가기',
    'guest.done.title': '준비 완료',
    'guest.done.body': '즐거운 둘러보기 되세요!',
  },

  en: {
    'common.skip': 'Skip tutorial',
    'common.next': 'Next',
    'common.prev': 'Back',
    'common.done': 'Done',
    'common.start': 'Get started',
    'common.gotIt': 'Got it',
    'common.progress': 'Step {i}/{n}',
    'common.replay_button': 'Replay tutorial',
    'common.replay_desc': 'Watch the app guide again from the beginning.',
    'common.replay_section': 'App guide',
    'common.show_steps': 'Show all steps',
    'common.hide_steps': 'Hide all steps',
    'common.steps_panel_label': 'Tutorial progress',

    'picker.title': 'Choose your language',
    'picker.subtitle': 'The app and the tutorial will both use this language, and your selection is saved to your profile.',
    'picker.note': 'You can change this anytime from Settings.',
    'picker.step_title': 'Language selection',

    'shared.open_menu.title': 'Open the menu',
    'shared.open_menu.body': 'Tap the menu (☰) icon at the top-left to open the side menu.',

    // ---- COMPANY ----
    'company.welcome.title': 'Welcome!',
    'company.welcome.body': 'First time on {eventName}? We will walk you through the key features. You can leave anytime via "Skip tutorial" at the top.',
    'company.companies.title': 'Browse exhibitors',
    'company.companies.body': 'Open "Companies" to look around other exhibitors and discover collaboration opportunities.',
    'company.events.title': 'Check the schedule',
    'company.events.body': '"Events" lists conferences, networking, pitches and more across {eventName}.',
    'company.matching.title': 'Go to AI Matching',
    'company.matching.body': '👉 Please click the "Matching" button on the left menu now. It will take you to the AI-powered matching screen.',
    'company.aiBtn.title': 'Interest-Based Analysis',
    'company.aiBtn.body': '👉 Please click the highlighted "Interest-Based Analysis" button to start the AI analysis.',
    'company.analyzing.title': 'AI Analyzing',
    'company.analyzing.body': 'You will see "AI Analyzing..." for about 30 seconds. Please wait.',
    'company.analyzed.title': 'Analyzed!',
    'company.analyzed.body': 'The "Analyzed" badge appears at the top. Your matches are ready.',
    'company.chats.title': 'Business chat',
    'company.chats.body': 'Message companies you are interested in and propose meetings directly.',
    'company.profile.title': 'Manage your company info',
    'company.profile.body': '"Profile" is where you edit your company description, contacts and booth information.',
    'company.carbon.title': 'Carbon reduction',
    'company.carbon.body': 'Logging eco-friendly activities accumulates your carbon reduction. Check the widget at the bottom of the menu.',
    'company.done.title': 'You are all set',
    'company.done.body': 'Nice work! You can replay this guide anytime from "Settings → App guide".',

    // ---- BUYER verified ----
    'buyer.welcome.title': 'Welcome, buyer!',
    'buyer.welcome.body': 'Interest-based AI matching helps you find suppliers fast. Here are the key features.',
    'buyer.companies.title': 'Supplier catalog',
    'buyer.companies.body': '"Companies" lets you browse suppliers by industry, size and technology.',
    'buyer.events.title': 'Check the schedule',
    'buyer.events.body': 'Bookmark conferences and networking events you would like to attend in "Events".',
    'buyer.matching.title': 'Go to AI Matching',
    'buyer.matching.body': '👉 Please click the "Matching" button on the left menu now to see recommendations based on your interests.',
    'buyer.aiBtn.title': 'Interest-Based Analysis',
    'buyer.aiBtn.body': '👉 Please click the highlighted "Interest-Based Analysis" button to run analysis on your interests.',
    'buyer.analyzing.title': 'AI Analyzing',
    'buyer.analyzing.body': '"AI Analyzing..." will be shown for about 30 seconds.',
    'buyer.analyzed.title': 'Analyzed!',
    'buyer.analyzed.body': 'The "Analyzed" badge appears at the top. Check your recommended suppliers.',
    'buyer.chats.title': 'Chat with suppliers',
    'buyer.chats.body': 'Message suppliers directly and propose meetings.',
    'buyer.profile.title': 'Manage your profile',
    'buyer.profile.body': 'Update your interests and contacts in "Profile" to improve match accuracy.',
    'buyer.carbon.title': 'Carbon reduction',
    'buyer.carbon.body': 'Logging eco-friendly activities accumulates your carbon reduction.',
    'buyer.done.title': 'You are all set',
    'buyer.done.body': 'Bookmark suppliers you like to find them all in one place. Replay anytime from "Settings → App guide".',

    // ---- BUYER pending ----
    'buyerPending.welcome.title': 'Approval pending',
    'buyerPending.welcome.body': 'Your buyer registration is being reviewed. Approval usually arrives within a few hours. Meanwhile, here is what you can explore.',
    'buyerPending.companies.title': 'Browse exhibitors',
    'buyerPending.companies.body': 'Open "Companies" to look around. Matching and chat unlock once approved.',
    'buyerPending.events.title': 'Check the schedule',
    'buyerPending.events.body': 'Bookmark events you would like to attend from "Events".',
    'buyerPending.profile.title': 'Your profile',
    'buyerPending.profile.body': 'Check your registration and approval status under "Profile". You will get a notification when approved.',
    'buyerPending.done.title': 'You are all set',
    'buyerPending.done.body': 'Matching and chat will unlock automatically once your account is approved.',

    // ---- BUSINESS_VISITOR verified ----
    'bizvisitor.welcome.title': 'Welcome, business visitor!',
    'bizvisitor.welcome.body': 'AI matching helps you find companies that match your interests. Here are the key features.',
    'bizvisitor.companies.title': 'Browse exhibitors',
    'bizvisitor.companies.body': '"Companies" lets you filter exhibitors by industry, size and technology.',
    'bizvisitor.events.title': 'Check the schedule',
    'bizvisitor.events.body': '"Events" lists conferences, networking and pitches.',
    'bizvisitor.matching.title': 'Go to AI Matching',
    'bizvisitor.matching.body': '👉 Please click the "Matching" button on the left menu now.',
    'bizvisitor.aiBtn.title': 'Interest-Based Analysis',
    'bizvisitor.aiBtn.body': '👉 Please click the highlighted "Interest-Based Analysis" button to start.',
    'bizvisitor.analyzing.title': 'AI Analyzing',
    'bizvisitor.analyzing.body': '"AI Analyzing..." will be shown for about 30 seconds.',
    'bizvisitor.analyzed.title': 'Analyzed!',
    'bizvisitor.analyzed.body': 'Check the "Analyzed" badge at the top.',
    'bizvisitor.chats.title': 'Chat with companies',
    'bizvisitor.chats.body': 'Message companies directly and propose meetings.',
    'bizvisitor.profile.title': 'Manage your profile',
    'bizvisitor.profile.body': 'Update your interests and contacts to improve match accuracy.',
    'bizvisitor.carbon.title': 'Carbon reduction',
    'bizvisitor.carbon.body': 'Logging eco-friendly activities accumulates your carbon reduction.',
    'bizvisitor.done.title': 'You are all set',
    'bizvisitor.done.body': 'Replay anytime from "Settings → App guide".',

    // ---- BUSINESS_VISITOR pending ----
    'bizvisitorPending.welcome.title': 'Approval pending',
    'bizvisitorPending.welcome.body': 'Your business visitor application is being reviewed. Matching and chat will unlock once approved. Here is what you can explore meanwhile.',
    'bizvisitorPending.companies.title': 'Browse exhibitors',
    'bizvisitorPending.companies.body': 'Open "Companies" to look around.',
    'bizvisitorPending.events.title': 'Check the schedule',
    'bizvisitorPending.events.body': 'Bookmark events you would like to attend.',
    'bizvisitorPending.profile.title': 'Your profile',
    'bizvisitorPending.profile.body': 'Check your approval status from "Profile". You will get a notification when approved.',
    'bizvisitorPending.done.title': 'You are all set',
    'bizvisitorPending.done.body': 'Matching and chat will open automatically once approved.',

    // ---- INVESTOR ----
    'investor.welcome.title': 'Welcome, investor!',
    'investor.welcome.body': 'Discover promising startups efficiently. Here are the key features.',
    'investor.companies.title': 'Browse startups',
    'investor.companies.body': 'Filter by category, size and investment stage in "Companies".',
    'investor.bookmark.title': 'Bookmark companies',
    'investor.bookmark.body': 'Tap the bookmark icon on company cards. Find them all later in "Profile → Bookmarks".',
    'investor.events.title': 'Pitches & networking',
    'investor.events.body': 'Check pitch sessions and networking events under "Events".',
    'investor.chats.title': 'Chat with companies',
    'investor.chats.body': 'Message companies directly and propose meetings.',
    'investor.profile.title': 'Manage your profile',
    'investor.profile.body': 'Update your investment focus and interests under "Profile".',
    'investor.done.title': 'You are all set',
    'investor.done.body': 'Replay anytime from "Settings → App guide".',

    // ---- VISITOR ----
    'visitor.welcome.title': 'Welcome to {eventName}',
    'visitor.welcome.body': 'A quick tour of the spots worth checking out.',
    'visitor.companies.title': 'Browse exhibitors',
    'visitor.companies.body': 'See exhibitors and booth locations in "Companies".',
    'visitor.events.title': 'Check the schedule',
    'visitor.events.body': 'Bookmark conferences and seminars you are interested in.',
    'visitor.carbon.title': 'Your carbon footprint',
    'visitor.carbon.body': 'Track your carbon reduction in the widget at the bottom of the menu.',
    'visitor.profile.title': 'Manage your profile',
    'visitor.profile.body': 'Manage your registration info and notification settings under "Profile".',
    'visitor.upgrade.title': 'Want chat and matching?',
    'visitor.upgrade.body': 'Chat, matching and meeting requests are business-member only. You can apply from your profile if interested.',
    'visitor.upgrade.cta': 'See business membership',
    'visitor.done.title': 'You are all set',
    'visitor.done.body': 'Enjoy the show! Replay anytime from "Settings → App guide".',

    // ---- GUEST ----
    'guest.welcome.title': 'Preview mode',
    'guest.welcome.body': 'A quick look at what you can see as a guest.',
    'guest.companies.title': 'Public catalog',
    'guest.companies.body': '"Companies" is open to guests as well.',
    'guest.events.title': 'Public schedule',
    'guest.events.body': '"Events" lets you preview the show schedule.',
    'guest.register.title': 'Sign up for full access',
    'guest.register.body': 'Chat, matching and meeting requests require an account. Signup takes under a minute.',
    'guest.register.cta': 'Go to sign up',
    'guest.done.title': 'You are all set',
    'guest.done.body': 'Enjoy looking around!',
  },

  ja: {
    'common.skip': 'チュートリアルをスキップ',
    'common.next': '次へ',
    'common.prev': '戻る',
    'common.done': '完了',
    'common.start': 'はじめる',
    'common.gotIt': 'わかりました',
    'common.progress': 'ステップ {i}/{n}',
    'common.replay_button': 'チュートリアルをもう一度見る',
    'common.replay_desc': 'アプリの使い方ガイドを最初から再生します。',
    'common.replay_section': 'アプリガイド',
    'common.show_steps': 'すべての手順を表示',
    'common.hide_steps': 'すべての手順を非表示',
    'common.steps_panel_label': 'チュートリアルの進行状況',

    'picker.title': '言語を選択してください',
    'picker.subtitle': '選択した言語でアプリとチュートリアルが表示され、プロフィールに保存されます。',
    'picker.note': '設定からいつでも変更できます。',
    'picker.step_title': '言語の選択',

    'shared.open_menu.title': 'メニューを開く',
    'shared.open_menu.body': '左上のメニュー(☰)ボタンをタップしてサイドメニューを開いてください。',

    'company.welcome.title': 'ようこそ!',
    'company.welcome.body': '{eventName}は初めてですね。主要機能を素早くご案内します。上部の「スキップ」でいつでも終了できます。',
    'company.companies.title': '出展企業を見る',
    'company.companies.body': '「企業」メニューから他の出展企業を見て、協業の機会を見つけましょう。',
    'company.events.title': '日程の確認',
    'company.events.body': '「日程」では{eventName}のカンファレンス、ネットワーキング、ピッチなどのイベント日程を確認できます。',
    'company.matching.title': 'AIマッチングへ',
    'company.matching.body': '👉 今すぐ左メニューの「マッチング」ボタンをクリックしてください。AIマッチング画面に移動します。',
    'company.aiBtn.title': 'Interest-Based Analysis',
    'company.aiBtn.body': '👉 強調された「類似企業分析」ボタンをクリックしてください。AI分析が始まります。',
    'company.analyzing.title': 'AI分析中',
    'company.analyzing.body': '約30秒間「AI Analyzing...」と表示されます。',
    'company.analyzed.title': '分析完了!',
    'company.analyzed.body': '上部に「Analyzed」バッジが表示されました。おすすめ結果をご確認ください。',
    'company.chats.title': 'ビジネスチャット',
    'company.chats.body': '気になる企業に直接メッセージを送り、ミーティングを提案できます。',
    'company.profile.title': '会社情報の管理',
    'company.profile.body': '「プロフィール」では会社紹介、担当者連絡先、ブース情報などを編集できます。',
    'company.carbon.title': 'カーボン削減',
    'company.carbon.body': 'エコ活動を記録するとカーボン削減量が積み上がります。メニュー下部のウィジェットで確認できます。',
    'company.done.title': '準備完了',
    'company.done.body': 'お疲れ様でした!「設定 → アプリガイド」からいつでも再生できます。',

    'buyer.welcome.title': 'ようこそ、バイヤー様',
    'buyer.welcome.body': '関心ベースのAIマッチングで最適な仕入先をご提案します。主要機能をご案内します。',
    'buyer.companies.title': 'サプライヤーカタログ',
    'buyer.companies.body': '「企業」メニューから業種・規模・技術別にサプライヤーを探せます。',
    'buyer.events.title': '日程の確認',
    'buyer.events.body': '参加したいカンファレンスやネットワーキングを「日程」でブックマークしておきましょう。',
    'buyer.matching.title': 'AIマッチングへ',
    'buyer.matching.body': '👉 今すぐ左メニューの「マッチング」ボタンをクリックしてください。おすすめ画面に移動します。',
    'buyer.aiBtn.title': 'Interest-Based Analysis',
    'buyer.aiBtn.body': '👉 強調された「類似企業分析」ボタンをクリックしてください。関心に基づく分析が始まります。',
    'buyer.analyzing.title': 'AI分析中',
    'buyer.analyzing.body': '約30秒間「AI Analyzing...」と表示されます。',
    'buyer.analyzed.title': '分析完了!',
    'buyer.analyzed.body': '上部に「Analyzed」バッジが表示されます。',
    'buyer.chats.title': 'サプライヤーとチャット',
    'buyer.chats.body': '気になるサプライヤーに直接メッセージを送り、ミーティングを提案できます。',
    'buyer.profile.title': 'プロフィール管理',
    'buyer.profile.body': '「プロフィール」で関心分野と連絡先を更新するとマッチング精度が上がります。',
    'buyer.carbon.title': 'カーボン削減',
    'buyer.carbon.body': 'エコ活動を記録するとカーボン削減量が積み上がります。',
    'buyer.done.title': '準備完了',
    'buyer.done.body': '気になる企業はブックマークしておくと後でまとめて見られます。',

    'buyerPending.welcome.title': '承認待ち',
    'buyerPending.welcome.body': 'バイヤー登録が審査中です。通常は数時間以内に承認されます。その間にできることをご案内します。',
    'buyerPending.companies.title': '出展企業を見る',
    'buyerPending.companies.body': '「企業」メニューから出展企業を見ることができます。マッチング/チャットは承認後に解放されます。',
    'buyerPending.events.title': '日程の確認',
    'buyerPending.events.body': '「日程」から参加したいイベントをブックマークしておきましょう。',
    'buyerPending.profile.title': 'プロフィール',
    'buyerPending.profile.body': '「プロフィール」で登録情報と承認状況を確認できます。承認されると通知が届きます。',
    'buyerPending.done.title': 'ご案内完了',
    'buyerPending.done.body': '承認されるとマッチング/チャット機能が自動で開放されます。',

    'bizvisitor.welcome.title': 'ようこそ、ビジネスビジターの方',
    'bizvisitor.welcome.body': 'AIマッチングで関心分野の企業を素早く見つけられます。主要機能をご案内します。',
    'bizvisitor.companies.title': '出展企業を見る',
    'bizvisitor.companies.body': '「企業」メニューから業種・規模・技術別に企業を探せます。',
    'bizvisitor.events.title': '日程の確認',
    'bizvisitor.events.body': '「日程」でカンファレンス・ネットワーキング・ピッチを確認できます。',
    'bizvisitor.matching.title': 'AIマッチングへ',
    'bizvisitor.matching.body': '👉 今すぐ左メニューの「マッチング」ボタンをクリックしてください。',
    'bizvisitor.aiBtn.title': 'Interest-Based Analysis',
    'bizvisitor.aiBtn.body': '👉 強調された「類似企業分析」ボタンをクリックしてください。',
    'bizvisitor.analyzing.title': 'AI分析中',
    'bizvisitor.analyzing.body': '約30秒間「AI Analyzing...」と表示されます。',
    'bizvisitor.analyzed.title': '分析完了!',
    'bizvisitor.analyzed.body': '上部の「Analyzed」バッジを確認してください。',
    'bizvisitor.chats.title': '企業とチャット',
    'bizvisitor.chats.body': '気になる企業に直接メッセージを送りミーティングを提案できます。',
    'bizvisitor.profile.title': 'プロフィール管理',
    'bizvisitor.profile.body': '関心分野と連絡先を更新するとマッチング精度が上がります。',
    'bizvisitor.carbon.title': 'カーボン削減',
    'bizvisitor.carbon.body': 'エコ活動を記録するとカーボン削減量が積み上がります。',
    'bizvisitor.done.title': '準備完了',
    'bizvisitor.done.body': '「設定 → アプリガイド」からいつでも再生できます。',

    'bizvisitorPending.welcome.title': '承認待ち',
    'bizvisitorPending.welcome.body': 'ビジネスビジターの申請を受け付けました。承認後にマッチング/チャットが解放されます。',
    'bizvisitorPending.companies.title': '出展企業を見る',
    'bizvisitorPending.companies.body': '「企業」を開いて見渡してみましょう。',
    'bizvisitorPending.events.title': '日程の確認',
    'bizvisitorPending.events.body': '参加したいイベントをブックマークしておきましょう。',
    'bizvisitorPending.profile.title': 'プロフィール',
    'bizvisitorPending.profile.body': '「プロフィール」で承認状況を確認できます。',
    'bizvisitorPending.done.title': 'ご案内完了',
    'bizvisitorPending.done.body': '承認されるとマッチング/チャットが自動で開きます。',

    'investor.welcome.title': 'ようこそ、投資家の方',
    'investor.welcome.body': '注目すべきスタートアップを効率よく発掘できます。主要機能をご案内します。',
    'investor.companies.title': 'スタートアップ探索',
    'investor.companies.body': '「企業」からカテゴリ・規模・投資ステージで絞り込めます。',
    'investor.bookmark.title': '気になる企業をブックマーク',
    'investor.bookmark.body': '企業カードのブックマークアイコンをタップ。後で「プロフィール → ブックマーク」でまとめて確認できます。',
    'investor.events.title': 'ピッチ・ネットワーキング',
    'investor.events.body': '「日程」でピッチセッションやネットワーキングを確認しましょう。',
    'investor.chats.title': '企業とチャット',
    'investor.chats.body': '気になる企業と直接やり取りし、ミーティングを提案できます。',
    'investor.profile.title': 'プロフィール管理',
    'investor.profile.body': '投資領域や関心分野を「プロフィール」で更新しましょう。',
    'investor.done.title': '準備完了',
    'investor.done.body': '「設定 → アプリガイド」からいつでも再生できます。',

    'visitor.welcome.title': '{eventName}へようこそ',
    'visitor.welcome.body': '見どころを素早くご案内します。',
    'visitor.companies.title': '出展企業を見る',
    'visitor.companies.body': '「企業」から出展企業とブースの位置を確認できます。',
    'visitor.events.title': '日程の確認',
    'visitor.events.body': '関心のあるカンファレンス/セミナーを「日程」でブックマークしておきましょう。',
    'visitor.carbon.title': '私のCO2削減量',
    'visitor.carbon.body': 'メニュー下部のカーボンウィジェットで削減量を確認できます。',
    'visitor.profile.title': 'プロフィール管理',
    'visitor.profile.body': '「プロフィール」で登録情報と通知設定を管理できます。',
    'visitor.upgrade.title': 'チャットやマッチングを使いたい場合',
    'visitor.upgrade.body': 'チャット/マッチング/ミーティング依頼はビジネス会員専用です。プロフィールから申請できます。',
    'visitor.upgrade.cta': 'ビジネス会員を確認',
    'visitor.done.title': '準備完了',
    'visitor.done.body': 'よい観覧をお楽しみください!',

    'guest.welcome.title': 'プレビュー モード',
    'guest.welcome.body': 'ゲストで見られる範囲をご案内します。',
    'guest.companies.title': '公開カタログ',
    'guest.companies.body': '「企業」はゲストでも自由に閲覧できます。',
    'guest.events.title': '公開日程',
    'guest.events.body': '「日程」でショーのスケジュールを確認できます。',
    'guest.register.title': '会員登録で全機能を利用',
    'guest.register.body': 'チャット/マッチング/ミーティング依頼は会員専用です。1分で登録できます。',
    'guest.register.cta': '会員登録へ',
    'guest.done.title': '準備完了',
    'guest.done.body': 'ごゆっくりご覧ください!',
  },

  zh: {
    'common.skip': '跳过教程',
    'common.next': '下一步',
    'common.prev': '上一步',
    'common.done': '完成',
    'common.start': '开始',
    'common.gotIt': '知道了',
    'common.progress': '步骤 {i}/{n}',
    'common.replay_button': '重新播放教程',
    'common.replay_desc': '从头再看一次应用使用指南。',
    'common.replay_section': '应用指南',
    'common.show_steps': '显示全部步骤',
    'common.hide_steps': '隐藏全部步骤',
    'common.steps_panel_label': '教程进度',

    'picker.title': '请选择语言',
    'picker.subtitle': '所选语言将用于应用和教程,并保存到您的个人档案。',
    'picker.note': '您可以随时在设置中更改。',
    'picker.step_title': '选择语言',

    'shared.open_menu.title': '打开菜单',
    'shared.open_menu.body': '点击左上角菜单(☰)按钮以展开侧边菜单。',

    'company.welcome.title': '欢迎!',
    'company.welcome.body': '第一次使用 {eventName} 吗?我们将快速介绍核心功能。可随时点击右上的"跳过教程"。',
    'company.companies.title': '浏览参展企业',
    'company.companies.body': '在"企业"菜单中浏览其他参展企业,发现合作机会。',
    'company.events.title': '查看日程',
    'company.events.body': '"日程"列出 {eventName} 的会议、社交、路演等所有活动。',
    'company.matching.title': '前往 AI 匹配',
    'company.matching.body': '👉 现在请点击左侧菜单的"匹配"按钮,即可前往 AI 匹配页面。',
    'company.aiBtn.title': 'Interest-Based Analysis',
    'company.aiBtn.body': '👉 请点击高亮的"类似企业分析"按钮以开始 AI 分析。',
    'company.analyzing.title': 'AI 分析中',
    'company.analyzing.body': '将显示约 30 秒的 "AI Analyzing..."。',
    'company.analyzed.title': '分析完成!',
    'company.analyzed.body': '顶部出现 "Analyzed" 徽章,请查看推荐结果。',
    'company.chats.title': '商务聊天',
    'company.chats.body': '直接向感兴趣的企业发送消息并提议会议。',
    'company.profile.title': '管理公司信息',
    'company.profile.body': '在"个人页"中编辑公司介绍、联系人和展位信息。',
    'company.carbon.title': '碳减排',
    'company.carbon.body': '记录环保活动可累积您的碳减排量。在菜单底部的小组件中查看。',
    'company.done.title': '准备完成',
    'company.done.body': '在 设置 → 应用指南 中可随时再次观看。',

    'buyer.welcome.title': '欢迎,采购方!',
    'buyer.welcome.body': '基于兴趣的 AI 匹配将帮您快速找到合适的供应方。下面是核心功能。',
    'buyer.companies.title': '供应商目录',
    'buyer.companies.body': '在"企业"中按行业、规模、技术筛选供应商。',
    'buyer.events.title': '查看日程',
    'buyer.events.body': '在"日程"中收藏您感兴趣的会议和社交活动。',
    'buyer.matching.title': '前往 AI 匹配',
    'buyer.matching.body': '👉 现在请点击左侧菜单的"匹配"按钮,查看基于您兴趣的推荐。',
    'buyer.aiBtn.title': 'Interest-Based Analysis',
    'buyer.aiBtn.body': '👉 请点击高亮的"类似企业分析"按钮,基于您的兴趣开始分析。',
    'buyer.analyzing.title': 'AI 分析中',
    'buyer.analyzing.body': '将显示约 30 秒的 "AI Analyzing..."。',
    'buyer.analyzed.title': '分析完成!',
    'buyer.analyzed.body': '顶部出现 "Analyzed" 徽章,请查看您的供应商推荐。',
    'buyer.chats.title': '与供应商聊天',
    'buyer.chats.body': '直接向供应商发送消息并提议会议。',
    'buyer.profile.title': '管理个人页',
    'buyer.profile.body': '在"个人页"中更新兴趣和联系方式可提高匹配精度。',
    'buyer.carbon.title': '碳减排',
    'buyer.carbon.body': '记录环保活动可累积您的碳减排量。',
    'buyer.done.title': '准备完成',
    'buyer.done.body': '将感兴趣的企业加入书签,稍后可一并查看。',

    'buyerPending.welcome.title': '审核中',
    'buyerPending.welcome.body': '您的采购方注册正在审核,通常会在数小时内通过。同时您可以浏览以下内容。',
    'buyerPending.companies.title': '浏览参展企业',
    'buyerPending.companies.body': '在"企业"中浏览参展企业。匹配/聊天功能将在审核通过后开放。',
    'buyerPending.events.title': '查看日程',
    'buyerPending.events.body': '在"日程"中收藏您感兴趣的活动。',
    'buyerPending.profile.title': '个人页',
    'buyerPending.profile.body': '在"个人页"中可查看注册和审核状态。审核通过后会立即收到通知。',
    'buyerPending.done.title': '指引结束',
    'buyerPending.done.body': '审核通过后,匹配/聊天功能将自动开放。',

    'bizvisitor.welcome.title': '欢迎,商务访客!',
    'bizvisitor.welcome.body': 'AI 匹配可帮您快速找到关注领域的企业。下面是核心功能。',
    'bizvisitor.companies.title': '浏览参展企业',
    'bizvisitor.companies.body': '在"企业"中按行业、规模、技术筛选。',
    'bizvisitor.events.title': '查看日程',
    'bizvisitor.events.body': '"日程"列出会议、社交、路演活动。',
    'bizvisitor.matching.title': '前往 AI 匹配',
    'bizvisitor.matching.body': '👉 现在请点击侧边栏的"匹配"按钮。',
    'bizvisitor.aiBtn.title': 'Interest-Based Analysis',
    'bizvisitor.aiBtn.body': '👉 请点击高亮的"类似企业分析"按钮即可开始。',
    'bizvisitor.analyzing.title': 'AI 分析中',
    'bizvisitor.analyzing.body': '将显示约 30 秒的 "AI Analyzing..."。',
    'bizvisitor.analyzed.title': '分析完成!',
    'bizvisitor.analyzed.body': '请查看顶部的 "Analyzed" 徽章。',
    'bizvisitor.chats.title': '与企业聊天',
    'bizvisitor.chats.body': '直接向企业发送消息并提议会议。',
    'bizvisitor.profile.title': '管理个人页',
    'bizvisitor.profile.body': '更新兴趣和联系方式可提高匹配精度。',
    'bizvisitor.carbon.title': '碳减排',
    'bizvisitor.carbon.body': '记录环保活动可累积您的碳减排量。',
    'bizvisitor.done.title': '准备完成',
    'bizvisitor.done.body': '在 设置 → 应用指南 中可随时再次观看。',

    'bizvisitorPending.welcome.title': '审核中',
    'bizvisitorPending.welcome.body': '您的商务访客申请已收到。通过后将开放匹配/聊天功能。',
    'bizvisitorPending.companies.title': '浏览参展企业',
    'bizvisitorPending.companies.body': '在"企业"中先看看吧。',
    'bizvisitorPending.events.title': '查看日程',
    'bizvisitorPending.events.body': '收藏您感兴趣的活动。',
    'bizvisitorPending.profile.title': '个人页',
    'bizvisitorPending.profile.body': '在"个人页"中查看审核状态。',
    'bizvisitorPending.done.title': '指引结束',
    'bizvisitorPending.done.body': '通过审核后将自动开放匹配/聊天功能。',

    'investor.welcome.title': '欢迎,投资人!',
    'investor.welcome.body': '高效发现值得关注的初创企业。下面是核心功能。',
    'investor.companies.title': '探索初创企业',
    'investor.companies.body': '在"企业"中按行业、规模、投资阶段筛选。',
    'investor.bookmark.title': '收藏感兴趣的企业',
    'investor.bookmark.body': '点击企业卡片上的书签图标,可在 个人页 → 书签 中统一查看。',
    'investor.events.title': '路演与社交活动',
    'investor.events.body': '在"日程"中查看路演和社交活动。',
    'investor.chats.title': '与企业聊天',
    'investor.chats.body': '直接向企业发送消息并提议会议。',
    'investor.profile.title': '管理个人页',
    'investor.profile.body': '在"个人页"中更新投资领域和兴趣。',
    'investor.done.title': '准备完成',
    'investor.done.body': '在 设置 → 应用指南 中可随时再次观看。',

    'visitor.welcome.title': '欢迎来到 {eventName}',
    'visitor.welcome.body': '快速指引几个值得一看的地方。',
    'visitor.companies.title': '浏览参展企业',
    'visitor.companies.body': '在"企业"中查看参展企业和展位位置。',
    'visitor.events.title': '查看日程',
    'visitor.events.body': '收藏您感兴趣的会议和研讨会。',
    'visitor.carbon.title': '我的碳减排',
    'visitor.carbon.body': '在菜单底部的碳排量小组件中查看您的减排量。',
    'visitor.profile.title': '管理个人页',
    'visitor.profile.body': '在"个人页"中管理注册信息和通知设置。',
    'visitor.upgrade.title': '想使用聊天和匹配?',
    'visitor.upgrade.body': '聊天/匹配/会议邀请仅限商务会员。如有兴趣,可在个人页申请。',
    'visitor.upgrade.cta': '查看商务会员',
    'visitor.done.title': '准备完成',
    'visitor.done.body': '祝您观展愉快!',

    'guest.welcome.title': '预览模式',
    'guest.welcome.body': '一起看看以游客身份能浏览哪些内容。',
    'guest.companies.title': '公开目录',
    'guest.companies.body': '"企业"对游客同样开放。',
    'guest.events.title': '公开日程',
    'guest.events.body': '"日程"中可以预览展会日程。',
    'guest.register.title': '注册以使用全部功能',
    'guest.register.body': '聊天/匹配/会议邀请仅限会员。注册不到一分钟。',
    'guest.register.cta': '前往注册',
    'guest.done.title': '准备完成',
    'guest.done.body': '祝您浏览愉快!',
  },
};

// 멀티테넌트: {eventName} 플레이스홀더는 모든 호출에서 자동으로 활성 tenant 의
// 행사명으로 치환된다 (DSK → 'DSK 2026', AP → 'AI Power +'). 호출자가 명시적
// eventName 을 넘기면 그 값을 우선 사용한다.
import { getEventName } from '../shared/config/tenant';

export function tt(key, lang, params = {}) {
  const dict = TRANSLATIONS[lang] || TRANSLATIONS.ko;
  let str = dict[key];
  if (str == null) {
    str = TRANSLATIONS.ko[key];
  }
  if (str == null) {
    return key;
  }
  const allParams = { eventName: getEventName(), ...(params || {}) };
  Object.keys(allParams).forEach((p) => {
    str = str.replace(new RegExp('\\{' + p + '\\}', 'g'), allParams[p]);
  });
  return str;
}

export default { tt };
